import { render, staticRenderFns } from "./MetabaseConfig.vue?vue&type=template&id=6e6654eb&scoped=true&"
import script from "./MetabaseConfig.vue?vue&type=script&lang=js&"
export * from "./MetabaseConfig.vue?vue&type=script&lang=js&"
import style0 from "./MetabaseConfig.vue?vue&type=style&index=0&id=6e6654eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6654eb",
  null
  
)

export default component.exports